import type { OAuthApi, ProfileInfoApi, BackstageIdentityApi } from '@backstage/core-plugin-api';

type GitLabAuthApi = OAuthApi & ProfileInfoApi & BackstageIdentityApi;

function sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export function isPopupClosedAuthError(err: unknown): boolean {
  const name = err instanceof Error ? err.name : '';
  const message = (err instanceof Error ? err.message : String(err)).toLowerCase();
  return (
    name === 'PopupClosedError' ||
    name === 'PopupRejectedError' ||
    message.includes('popup was closed') ||
    message.includes('popup closed')
  );
}

/**
 * Incognito + GitLab popup often reports PopupClosedError even after a successful
 * OAuth. Probe for a session that was stored anyway.
 */
export async function recoverIdentityAfterPopupClosed(
  authApi: GitLabAuthApi,
  options?: { attempts?: number; delayMs?: number },
): Promise<boolean> {
  const attempts = options?.attempts ?? 8;
  const delayMs = options?.delayMs ?? 400;

  for (let attempt = 0; attempt < attempts; attempt++) {
    if (attempt > 0) {
      await sleep(delayMs * Math.min(attempt, 4));
    }
    try {
      const identity = await authApi.getBackstageIdentity({ optional: true });
      if (identity) {
        return true;
      }
    } catch {
      /* still settling */
    }
  }
  return false;
}
